var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"appDialog-container",attrs:{"persistent":"","max-width":"512"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true),model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}})
}
var staticRenderFns = []

export { render, staticRenderFns }